import {MODAL_TYPE, showModal} from '../../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {NovaWorkflowVersionHistoryModalProps} from './NovaWorkflowVersionHistoryModal';

export type NovaWorkflowVersionHistoryModalPayload = Omit<NovaWorkflowVersionHistoryModalProps, 'onClose'>;

export const showNovaWorkflowVersionHistoryModal = (props: NovaWorkflowVersionHistoryModalPayload): void => {
	showModal({type: MODAL_TYPE.NOVA_WORKFLOW_VERSION_HISTORY, ...props});
};
